import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-pd-alt': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M247.6 8C389.4 8 496 118.1 496 256 496 403.1 377.5 504 247.6 504 113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zM248.4 52.7C130.2 52.7 44.7 150.6 44.7 256 44.7 365.8 135.9 458.8 248.4 458.8 351.6 458.8 451.2 377.7 451.2 256 451.3 142.2 361 52.7 248.4 52.7zM135.5 323.3V186H203.7C237.4 186 254.2 201.5 254.2 232.5 254.2 241.5 251.2 279 197.1 279H170.1V323.3H135.5zM169.6 211.7V253.3H198.8C226.7 253.3 228.8 211.7 197.9 211.7H169.6zM263.5 323.3V186H316.7C338.1 186 386.7 191.2 386.7 254.6 386.7 318.1 338.1 323.2 316.7 323.2H263.5zM297.6 214.8V294.5H317.5C341.5 294.5 352 279.2 352 254.6 352 212.6 320.8 214.7 317 214.7L297.6 214.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/creative-commons-pd-alt.js
// module id = VF/K
// module chunks = 144